export default __webpack_public_path__ + "static/media/website.e511737f.png";